import { jsx as _jsx } from "react/jsx-runtime";
import SubmitButton from '../../../../../components/Buttons/submitButton';
export const DepositAddressFormButtonView = ({ waitingForAddress, copied, onCopy, isValid, error, isSubmitting, showDepositInfo, depositAddress, isProcessing, isCompleted, hasDepositError, onDepositMore, onRetry, }) => {
    if (isCompleted) {
        return (_jsx(SubmitButton, { type: "button", onClick: onDepositMore, children: "Deposit more" }));
    }
    if (isProcessing) {
        return null;
    }
    if (hasDepositError) {
        return (_jsx(SubmitButton, { type: "button", buttonStyle: "secondary", onClick: onRetry, isDisabled: !isValid, isSubmitting: isSubmitting, children: "Retry" }));
    }
    if (showDepositInfo && depositAddress) {
        return (_jsx(SubmitButton, { type: "button", onClick: onCopy, children: copied ? 'Copied!' : 'Copy deposit address' }));
    }
    const label = error ||
        (waitingForAddress
            ? 'Enter destination address'
            : 'Generating deposit address');
    return (_jsx(SubmitButton, { type: "button", isDisabled: true, isSubmitting: !waitingForAddress && isValid && !error && isSubmitting, children: label }));
};
